/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import {
  Filter,
  RefreshCw,
  Moon,
  DollarSign,
  X,
  Cloud,
  Server,
  Tag,
  TrendingUp,
  TrendingDown,
  Briefcase
} from 'lucide-react';

import TablasCompactas from '../../components/billing/TablasCompactas';
import GraficasPieBilling from '../../components/billing/GraficasPieBilling';
import HorasXStatus from '../../components/billing/HorasXStatus';
import DetalleFacturacionTable from '../../components/billing/DetalleFacturacionTable';
import ClienteDropdown from '../../components/billing/ClienteDropdown';

import {
  fetchBillingFiltros,
  fetchBillingDashboard,
  fetchTipoCambio
} from '../../api';

export default function BillingDashboard() {
  /* =========================
     Estados principales
  ========================= */
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  /* =========================
     Fecha actual
  ========================= */
  const currentDate = new Date();
  const currentMonth = currentDate
    .toLocaleString('en-US', { month: 'long' })
    .toLowerCase();
  const currentYear = currentDate.getFullYear().toString();
  const currentMonthYear = `${currentMonth} ${currentYear}`;

  /* =========================
     Filtros
  ========================= */
    const [selectedMeses, setSelectedMeses] = useState([]);
    const [selectedFabricantes, setSelectedFabricantes] = useState([]);
    const [selectedClientes, setSelectedClientes] = useState([]);
    const [selectedServicios, setSelectedServicios] = useState([]);
    const [selectedMonedas, setSelectedMonedas] = useState(['USD']); // Default: USD
    const [selectedProveedores, setSelectedProveedores] = useState([]);
    const [selectedTipoFacturacion, setSelectedTipoFacturacion] = useState('Todos'); // Default: Todos

  /* =========================
     Datos (RAW - sin conversión)
  ========================= */
  const [statsRaw, setStatsRaw] = useState({
    total_precio_neto: 0,
    total_costo_real: 0,
    total_utilidad: 0,
    total_descuento_aplicado: 0,
    margen_promedio: 0,
    total_clientes: 0
  });

  const [tipoRegistroDataRaw, setTipoRegistroDataRaw] = useState([]);
  const [precioXFabricanteDataRaw, setPrecioXFabricanteDataRaw] = useState([]);
  const [precioXProveedorDataRaw, setPrecioXProveedorDataRaw] = useState([]);
  const [precioXClienteDataRaw, setPrecioXClienteDataRaw] = useState([]);
  const [detalleDataRaw, setDetalleDataRaw] = useState([]);
  const [resumenServicioDataRaw, setResumenServicioDataRaw] = useState([]);
  const [evolucionDataRaw, setEvolucionDataRaw] = useState([]);

  /* =========================
     Datos (CONVERTIDOS por moneda)
  ========================= */
  const [stats, setStats] = useState({ total_precio_neto: 0, total_costo_real: 0, total_utilidad: 0, total_descuento_aplicado: 0, margen_promedio: 0, total_clientes: 0 });
  const [tipoRegistroData, setTipoRegistroData] = useState([]);
  const [precioXFabricanteData, setPrecioXFabricanteData] = useState([]);
  const [precioXProveedorData, setPrecioXProveedorData] = useState([]);
  const [precioXClienteData, setPrecioXClienteData] = useState([]);
  const [detalleData, setDetalleData] = useState([]);
  const [resumenServicioData, setResumenServicioData] = useState([]);
  const [evolucionData, setEvolucionData] = useState([]);

  /* =========================
     Conversión de moneda
  ========================= */
  const [monedaVisualizacion, setMonedaVisualizacion] = useState('USD'); // Default: USD
  const [tiposCambio, setTiposCambio] = useState([]); // Datos de tipos de cambio reales

  /* =========================
     Filtros disponibles
  ========================= */
  const [filtrosDisponibles, setFiltrosDisponibles] = useState({
    meses: [],
    fabricantes: [],
    clientes: [],
    servicios: [],
    monedas: ['USD', 'MXN'],
    proveedores: [],
    tiposFacturacion: []
  });

  /* =========================
     Filtros disponibles (filtrados dinámicamente)
  ========================= */
  const [filtrosDisponiblesFiltrados, setFiltrosDisponiblesFiltrados] = useState({
    meses: [],
    fabricantes: [],
    clientes: [],
    servicios: [],
    monedas: ['USD', 'MXN'],
    proveedores: [],
    tiposFacturacion: []
  });

  /* =========================
     Utilidades
  ========================= */
  const ordenarMeses = (meses) => {
    const ordenMeses = {
      january: 1,
      february: 2,
      march: 3,
      april: 4,
      may: 5,
      june: 6,
      july: 7,
      august: 8,
      september: 9,
      october: 10,
      november: 11,
      december: 12
    };

    return meses.sort((a, b) => {
      const [mesA, anioA] = a.split(' ');
      const [mesB, anioB] = b.split(' ');

      if (anioA !== anioB) {
        return parseInt(anioB) - parseInt(anioA);
      }
      return ordenMeses[mesB] - ordenMeses[mesA];
    });
  };

  /* =========================
     FUNCIONES DE CONVERSIÓN DE MONEDA
  ========================= */
  const getTipoCambioForRecord = useCallback((record) => {
    if (!record || tiposCambio.length === 0) return null;
    
    const Proveedor = record.Proveedor || record.proveedor;
    const Fecha_Consumo = record.Mes || record.Fecha_Consumo || record.fecha_consumo;
    const Moneda_Consumo = record.Moneda || record.Moneda_Consumo || record.moneda || record.moneda_consumo;
    
    if (Moneda_Consumo !== 'MXN') return null;
    
    const recordDate = Fecha_Consumo?.split('T')[0] || Fecha_Consumo;
    const normalizedDate = recordDate && recordDate.length === 7 ? `${recordDate}-01` : recordDate;
    
    const getProviderKey = (proveedor) => {
      if (!proveedor) return null;
      const upper = proveedor.toUpperCase();
      if (upper.includes('GOOGLE')) return 'GOOGLE';
      if (upper.includes('AMAZON')) return 'AMAZON';
      if (upper.includes('MICROSOFT')) return 'AMAZON';
      if (upper.includes('HUAWEI')) return 'AMAZON';
      return null;
    };
    
    const providerKey = getProviderKey(Proveedor);
    
    if (providerKey === 'GOOGLE') {
      const tc = tiposCambio.find(t => {
        const tFecha = t.Fecha_Consumo || t.fecha_consumo;
        const tMoneda = t.Moneda || t.moneda;
        const tProveedor = t.Proveedor || t.proveedor;
        return tFecha === normalizedDate && tMoneda === 'MXN' && tProveedor?.toUpperCase().includes('GOOGLE');
      });
      if (tc?.Tipo_Cambio || tc?.tipo_cambio) return tc.Tipo_Cambio || tc.tipo_cambio;
    }
    
    if (providerKey === 'AMAZON' || providerKey === 'MICROSOFT' || providerKey === 'HUAWEI') {
      const tc = tiposCambio.find(t => {
        const tFecha = t.Fecha_Consumo || t.fecha_consumo;
        const tMoneda = t.Moneda || t.moneda;
        const tProveedor = t.Proveedor || t.proveedor;
        return tFecha === normalizedDate && tMoneda === 'MXN' && tProveedor?.toUpperCase().includes('AMAZON');
      });
      if (tc?.Tipo_Cambio || tc?.tipo_cambio) return tc.Tipo_Cambio || tc.tipo_cambio;
    }
    
    const anyTC = tiposCambio.find(t => {
      const tFecha = t.Fecha_Consumo || t.fecha_consumo;
      const tMoneda = t.Moneda || t.moneda;
      return tFecha === normalizedDate && tMoneda === 'MXN';
    });
    if (anyTC?.Tipo_Cambio || anyTC?.tipo_cambio) return anyTC.Tipo_Cambio || anyTC.tipo_cambio;
    
    return null;
  }, [tiposCambio]);

  const convertValue = useCallback((value, record, targetMoneda) => {
    const num = parseFloat(value) || 0;
    const recordMoneda = record.Moneda || record.Moneda_Consumo || record.moneda || record.moneda_consumo;
    
    if (!recordMoneda || recordMoneda === targetMoneda) return num;
    
    if (recordMoneda === 'MXN' && targetMoneda === 'USD') {
      const tc = getTipoCambioForRecord(record);
      return num / (tc || 18.0);
    }
    
    if (recordMoneda === 'USD' && targetMoneda === 'MXN') {
      const tc = getTipoCambioForRecord(record);
      return num * (tc || 18.0);
    }
    
    return num;
  }, [getTipoCambioForRecord]);

  /* Convertir datos cuando monedaVisualizacion cambia */
  useEffect(() => {
    console.log(`🔄 Convirtiendo datos a ${monedaVisualizacion}`);
    
    // Convertir stats
    if (statsRaw.total_precio_neto) {
      setStats(statsRaw);
    }
    
    // Convertir precioXClienteData (usa precio_neto lowercase)
    const convertedClientes = precioXClienteDataRaw.map(item => ({
      ...item,
      precio_neto: convertValue(item.precio_neto, item, monedaVisualizacion)
    }));
    setPrecioXClienteData(convertedClientes);
    console.log('   ✅ Clientes convertidos:', convertedClientes.slice(0, 2));
    
    // Convertir precioXFabricanteData
    const convertedFabricantes = precioXFabricanteDataRaw.map(item => ({
      ...item,
      precio_neto: convertValue(item.precio_neto, item, monedaVisualizacion)
    }));
    setPrecioXFabricanteData(convertedFabricantes);
    console.log('   ✅ Fabricantes convertidos:', convertedFabricantes.slice(0, 2));
    
    // Convertir precioXProveedorData
    const convertedProveedores = precioXProveedorDataRaw.map(item => ({
      ...item,
      precio_neto: convertValue(item.precio_neto, item, monedaVisualizacion)
    }));
    setPrecioXProveedorData(convertedProveedores);
    console.log('   ✅ Proveedores convertidos:', convertedProveedores.slice(0, 2));
    
    // Convertir resumenServicioData
    const convertedServicios = resumenServicioDataRaw.map(item => ({
      ...item,
      precio_neto: convertValue(item.precio_neto, item, monedaVisualizacion),
      costo_real: convertValue(item.costo_real, item, monedaVisualizacion)
    }));
    setResumenServicioData(convertedServicios);
    console.log('   ✅ Servicios convertidos:', convertedServicios.slice(0, 2));
    
    // Convertir evolucionData (si es necesario)
    const convertedEvolucion = evolucionDataRaw.map(item => ({
      ...item,
      precio_neto: convertValue(item.precio_neto, item, monedaVisualizacion)
    }));
    setEvolucionData(convertedEvolucion);
    
    // Convertir tipoRegistroData
    const convertedTipos = tipoRegistroDataRaw.map(item => ({
      ...item,
      precio_neto: convertValue(item.precio_neto, item, monedaVisualizacion)
    }));
    setTipoRegistroData(convertedTipos);
    
    // Para detalleData, pasamos RAW y DetalleFacturacionTable hace la conversión
    setDetalleData(detalleDataRaw);
    
  }, [monedaVisualizacion, tiposCambio, precioXClienteDataRaw, precioXFabricanteDataRaw, precioXProveedorDataRaw, resumenServicioDataRaw, evolucionDataRaw, tipoRegistroDataRaw, detalleDataRaw, convertValue]);

  /* =========================
     Cargar filtros
  ========================= */
  const loadFiltros = useCallback(async () => {
    try {
      const data = await fetchBillingFiltros();
      if (data.meses?.length) {
        data.meses = ordenarMeses(data.meses);

        const mesActualDisponible = data.meses.find((mes) => mes === currentMonthYear);
        const mesPorDefecto = mesActualDisponible || data.meses[0] || '';

        if (mesPorDefecto) {
          setSelectedMeses((prev) => (prev.length > 0 ? prev : [mesPorDefecto]));
        }
      }
      setFiltrosDisponibles(data);
    } catch (error) {
      console.error('❌ Error cargando filtros:', error);
    }
  }, [currentMonthYear]);

  /* =========================
     Cargar tipos de cambio
  ========================= */
  const loadTiposCambio = useCallback(async () => {
    try {
      const data = await fetchTipoCambio();
      setTiposCambio(data);
      console.log('✅ Tipos de cambio cargados:', data.length, 'registros');
    } catch (error) {
      console.error('❌ Error cargando tipos de cambio:', error);
      setTiposCambio([]);
    }
  }, []);

  /* =========================
     Mapeo Fabricante -> Proveedores reales
  ========================= */
  const getFabricante = (proveedor) => {
    if (!proveedor) return null;
    if (proveedor.includes('AMAZON')) return 'AWS';
    if (proveedor.includes('GOOGLE')) return 'GOOGLE';
    if (proveedor.includes('HUAWEI')) return 'HUAWEI';
    if (proveedor.includes('MICROSOFT')) return 'MICROSOFT';
    return null;
  };

  /* =========================
     Cargar datos
  ========================= */
  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      // Convertir fabricantes seleccionados (AWS, GOOGLE, etc.) a los proveedores reales del backend
      const proveedoresDeFabricantes = filtrosDisponibles.proveedores.filter(proveedor =>
        selectedFabricantes.some(fab => getFabricante(proveedor) === fab)
      );

      // Combinar proveedores específicos con los mapeados desde fabricante
      const todosProveedores = [
        ...selectedProveedores,
        ...proveedoresDeFabricantes.filter(p => !selectedProveedores.includes(p))
      ];

      // === LLAMADA 1: CON FILTRO DE MES (para datos generales) ===
      const filters = {
        mes: selectedMeses,
        cliente: selectedClientes,
        servicio: selectedServicios,
        moneda_fuente: selectedMonedas,
        proveedor: todosProveedores,
        tipo_facturacion: selectedTipoFacturacion
      };

      const data = await fetchBillingDashboard(filters);

      // Guardar datos RAW (sin conversión de moneda)
      setStatsRaw(data.stats || {});
      setTipoRegistroDataRaw(data.tipo_registro || []);
      setPrecioXFabricanteDataRaw(data.precio_x_fabricante || []);
      setPrecioXProveedorDataRaw(data.precio_x_proveedor || []);
      setPrecioXClienteDataRaw(data.precio_x_cliente || []);
      setDetalleDataRaw(data.detalle || []);
      setResumenServicioDataRaw(data.resumen_servicio || []);

      // === LLAMADA 2: SIN FILTRO DE MES (para evolución mensual de todo el año) ===
      const filtersEvolucion = {
        mes: [],
        cliente: selectedClientes,
        servicio: selectedServicios,
        moneda_fuente: selectedMonedas,
        proveedor: todosProveedores,
        tipo_facturacion: selectedTipoFacturacion
      };

      const dataEvolucion = await fetchBillingDashboard(filtersEvolucion);
      setEvolucionDataRaw(dataEvolucion.evolucion || []);

    } catch (error) {
      console.error('❌ Error cargando datos:', error);
    } finally {
      setLoading(false);
    }
  }, [
    selectedMeses,
    selectedFabricantes,
    selectedClientes,
    selectedServicios,
    selectedMonedas,
    selectedProveedores,    selectedTipoFacturacion,    filtrosDisponibles.proveedores
  ]);

  /* =========================
     Effects
  ========================= */
  useEffect(() => {
    loadFiltros();
    loadTiposCambio();
  }, [loadFiltros, loadTiposCambio]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!initialLoadComplete && filtrosDisponibles.meses.length > 0) {
      setInitialLoadComplete(true);
    }

    if (initialLoadComplete) {
      loadData();
    }
  }, [
    initialLoadComplete,
    filtrosDisponibles.meses,
    selectedMeses,
    selectedFabricantes,
    selectedServicios,
    selectedClientes,
    selectedMonedas,
    selectedProveedores,
    selectedTipoFacturacion,
    loadData
  ]);


  /* =========================
     Acciones
  ========================= */
  const handleManualRefresh = async () => {
    setRefreshing(true);
    await loadData();
    setRefreshing(false);
  };

  const addSelection = (setter, value) => {
    if (!value) return;
    setter((prev) => (prev.includes(value) ? prev : [...prev, value]));
  };

  const removeSelection = (setter, value) => {
    setter((prev) => prev.filter((item) => item !== value));
  };

  const clearAllFilters = () => {
    setSelectedMeses([]);
    setSelectedFabricantes([]);
    setSelectedClientes([]);
    setSelectedServicios([]);
    setSelectedMonedas([]);
    setSelectedProveedores([]);
    setSelectedTipoFacturacion('Todos');
  };

  /* =========================
     Lógica de filtros dependientes
  ========================= */
  useEffect(() => {
    let fabricantesDisponibles = filtrosDisponibles.fabricantes;
    let serviciosDisponibles = filtrosDisponibles.servicios;
    let clientesDisponibles = filtrosDisponibles.clientes;
    let proveedoresDisponibles = filtrosDisponibles.proveedores;

    const hayFiltro = selectedFabricantes.length > 0 || selectedServicios.length > 0 || selectedClientes.length > 0 || selectedProveedores.length > 0;
    
    if (hayFiltro) {
      const fabricantesEnDatos = new Set();
      const serviciosEnDatos = new Set();
      const clientesEnDatos = new Set();
      
      if (precioXProveedorData && precioXProveedorData.length > 0) {
        precioXProveedorData.forEach(item => {
          if (item && item.proveedor) {
            fabricantesEnDatos.add(item.proveedor);
          }
        });
      }

      if (tipoRegistroData && tipoRegistroData.length > 0) {
        tipoRegistroData.forEach(item => {
          if (item && item.servicio) {
            serviciosEnDatos.add(item.servicio);
          }
        });
      }

      if (precioXClienteData && precioXClienteData.length > 0) {
        precioXClienteData.forEach(item => {
          if (item && item.cliente) {
            clientesEnDatos.add(item.cliente);
          }
        });
      }

      if (resumenServicioData && resumenServicioData.length > 0) {
        resumenServicioData.forEach(item => {
          if (item && item.servicio) {
            serviciosEnDatos.add(item.servicio);
          }
        });
      }

      if (fabricantesEnDatos.size > 0) {
        fabricantesDisponibles = filtrosDisponibles.fabricantes.filter(f => fabricantesEnDatos.has(f));
      }
      
      if (clientesEnDatos.size > 0) {
        // Manejar clientes como strings o como objetos {nombre, cuenta}
        clientesDisponibles = filtrosDisponibles.clientes.filter(c => {
          const nombre = typeof c === 'string' ? c : c.nombre;
          return clientesEnDatos.has(nombre);
        });
      }

      if (serviciosEnDatos.size > 0) {
        serviciosDisponibles = filtrosDisponibles.servicios.filter(s => serviciosEnDatos.has(s));
      }
    }

    setFiltrosDisponiblesFiltrados({
      meses: filtrosDisponibles.meses,
      fabricantes: fabricantesDisponibles,
      clientes: clientesDisponibles,
      servicios: serviciosDisponibles,
      monedas: filtrosDisponibles.monedas,
      proveedores: proveedoresDisponibles,
      tiposFacturacion: filtrosDisponibles.tiposFacturacion
    });
  }, [selectedFabricantes, selectedServicios, selectedClientes, selectedProveedores, precioXProveedorData, tipoRegistroData, precioXClienteData, resumenServicioData, filtrosDisponibles]);

  /* =========================
     Handlers para clics interactivos
  ========================= */
  const handleFabricanteClick = (fabricante) => {
    if (selectedFabricantes.includes(fabricante)) {
      removeSelection(setSelectedFabricantes, fabricante);
    } else {
      addSelection(setSelectedFabricantes, fabricante);
    }
  };

  const handleClienteClick = (cliente) => {
    if (selectedClientes.includes(cliente)) {
      removeSelection(setSelectedClientes, cliente);
    } else {
      addSelection(setSelectedClientes, cliente);
    }
  };

  const handleServicioClick = (servicio) => {
    if (selectedServicios.includes(servicio)) {
      removeSelection(setSelectedServicios, servicio);
    } else {
      addSelection(setSelectedServicios, servicio);
    }
  };

  /* =========================
     Estilos
  ========================= */
  const cardClasses = isDarkMode
    ? 'bg-[#00261A] backdrop-blur-md border border-[#00FF66]/25 border-l-4 border-l-[#00FF66] rounded-xl p-6 shadow-lg hover:shadow-[0_0_28px_rgba(0,255,102,0.15)] hover:border-[#00FF66]/45 hover:-translate-y-[3px] [transition:all_.25s_ease]'
    : 'bg-white border border-emerald-200 border-l-4 border-l-emerald-500 rounded-xl p-6 shadow-lg hover:shadow-[0_4px_20px_rgba(0,200,80,0.12)] hover:border-emerald-400 transition-all duration-300';

  const textSecondary = isDarkMode ? 'text-[#a0c8b0]' : 'text-gray-600';

  const themeClasses = isDarkMode
    ? 'bg-[#001A12]'
    : 'bg-gradient-to-br from-emerald-50 via-green-50 to-teal-50';

  const selectClasses = isDarkMode
    ? 'w-full px-3 py-2 rounded-lg border bg-[#001f16] border-[#00FF66]/25 text-[#e0ffe8] hover:border-[#00FF66]/55 focus:outline-none focus:border-[#00FF66] focus:shadow-[0_0_8px_rgba(0,255,102,0.2)] [transition:all_.25s_ease]'
    : 'w-full px-3 py-2 rounded-lg border bg-white border-gray-300 text-gray-900 hover:border-emerald-400 focus:outline-none focus:border-emerald-500';

  const renderMultiFilter = ({ label, options, selectedValues, onAdd, onRemove, getOptionValue = (option) => option, getOptionLabel = (option) => option }) => {
    const normalizedOptions = Array.isArray(options) ? options : [];

    return (
      <div>
        <label className={`${textSecondary} text-xs mb-1 block`}>{label}</label>
        <select
          value=""
          onChange={(e) => onAdd(e.target.value)}
          style={isDarkMode ? { colorScheme: 'dark' } : {}}
          className={selectClasses}
        >
          <option value="">Seleccionar...</option>
          {normalizedOptions.map((option) => {
            const optionValue = getOptionValue(option);
            const optionLabel = getOptionLabel(option);
            return (
              <option key={optionValue} value={optionValue}>
                {optionLabel}
              </option>
            );
          })}
        </select>

        <div className="flex flex-wrap gap-2 mt-2 min-h-[28px]">
          {selectedValues.length === 0 ? (
            <span className={`${textSecondary} text-xs`}>Sin selección</span>
          ) : (
            selectedValues.map((value) => (
              <span
                key={value}
                className={isDarkMode
                  ? 'inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs bg-[#00FF66]/12 text-[#bff5d0] border border-[#00FF66]/35'
                  : 'inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs bg-emerald-100 text-emerald-700 border border-emerald-300'
                }
              >
                {value}
                <button
                  type="button"
                  onClick={() => onRemove(value)}
                  className={isDarkMode ? 'text-[#8be5ac] hover:text-white' : 'text-emerald-700 hover:text-emerald-900'}
                  title="Eliminar"
                >
                  <X className="w-3 h-3" />
                </button>
              </span>
            ))
          )}
        </div>
      </div>
    );
  };

  /* =========================
     Loader inicial
  ========================= */
  if (loading && !initialLoadComplete) {
    return (
      <div className={`min-h-screen ${themeClasses} flex items-center justify-center`}>
        <div className="flex items-center space-x-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00FF66]" />
          <span className="text-xl font-semibold text-[#00FF66]">
            Cargando Billing...
          </span>
        </div>
      </div>
    );
  }

  /* =========================
     Render
  ========================= */
  return (
      <div className={`min-h-screen ${themeClasses} transition-all duration-300`}>
        {/* Header */}
        <div className={isDarkMode
          ? 'bg-[#071a0f]/90 backdrop-blur-md border-b border-[#00FF66]/20 shadow-[0_2px_20px_rgba(0,255,102,0.08)]'
          : 'bg-white border-b border-emerald-200 shadow-sm'
        }>
          <div className="flex justify-between items-center px-6 py-5">
            <div>
              <div className="flex items-center gap-3 mb-1">
                <div className={isDarkMode
                  ? 'w-1 h-8 rounded-full bg-gradient-to-b from-[#00FF66] to-[#00ffb3]'
                  : 'w-1 h-8 rounded-full bg-gradient-to-b from-emerald-500 to-teal-400'
                } />
                <h1 className={isDarkMode
                  ? 'text-3xl font-bold bg-gradient-to-r from-[#00FF66] via-[#00ffb3] to-[#00FF66] bg-clip-text text-transparent'
                  : 'text-3xl font-bold text-emerald-700'
                }>
                  Billing
                </h1>
              </div>
              <p className={`${textSecondary} text-sm ml-4`}>
                Análisis Consolidado de Consumo Cloud
              </p>
            </div>
            
            <div className="flex items-center space-x-3">
              {/* Switch de moneda */}
              <div className={`flex items-center rounded-lg border px-1 py-1 ${isDarkMode ? 'bg-[#00261A] border-[#00FF66]/30' : 'bg-white border-emerald-300'}`}>
                <button
                  onClick={() => setMonedaVisualizacion('MXN')}
                  className={`px-3 py-1 rounded-md text-sm font-semibold transition-all ${
                    monedaVisualizacion === 'MXN'
                      ? isDarkMode
                        ? 'bg-[#00FF66]/20 text-[#00FF66] border border-[#00FF66]/40'
                        : 'bg-emerald-100 text-emerald-700 border border-emerald-300'
                      : isDarkMode
                        ? 'text-[#a0c8b0] hover:text-white'
                        : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  MXN
                </button>
                <div className={`w-px h-5 mx-1 ${isDarkMode ? 'bg-[#00FF66]/20' : 'bg-emerald-200'}`} />
                <button
                  onClick={() => setMonedaVisualizacion('USD')}
                  className={`px-3 py-1 rounded-md text-sm font-semibold transition-all ${
                    monedaVisualizacion === 'USD'
                      ? isDarkMode
                        ? 'bg-[#00FF66]/20 text-[#00FF66] border border-[#00FF66]/40'
                        : 'bg-emerald-100 text-emerald-700 border border-emerald-300'
                      : isDarkMode
                        ? 'text-[#a0c8b0] hover:text-white'
                        : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  USD
                </button>
              </div>

              <button
                onClick={handleManualRefresh}
                disabled={refreshing}
                className={`p-2 rounded-lg border transition-all ${
                  isDarkMode
                    ? 'bg-[#00FF66]/10 border-[#00FF66]/30 text-[#00FF66] hover:bg-[#00FF66]/20 hover:border-[#00FF66]/60'
                    : 'bg-emerald-50 border-emerald-300 text-emerald-700 hover:bg-emerald-100'
                } ${refreshing ? 'opacity-50 cursor-not-allowed' : ''}`}
                title="Actualizar datos"
              >
                <RefreshCw className={`w-5 h-5 ${refreshing ? 'animate-spin' : ''}`} />
              </button>
  
              <button
                onClick={() => setIsDarkMode(!isDarkMode)}
                className={`p-2 rounded-lg border transition-all ${
                  isDarkMode
                    ? 'bg-[#00FF66]/10 border-[#00FF66]/30 text-[#00FF66] hover:bg-[#00FF66]/20 hover:border-[#00FF66]/60'
                    : 'bg-emerald-50 border-emerald-300 text-emerald-700 hover:bg-emerald-100'
                }`}
                title={isDarkMode ? 'Modo claro' : 'Modo oscuro'}
              >
                <Moon className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
  
        {/* Contenido principal */}
        <div className="px-6 py-8 space-y-8">
          {/* Filtros */}
          <div className={cardClasses}>
            <div className="flex items-center justify-between gap-3 mb-4">
              <div className="flex items-center gap-3">
              <Filter className="w-5 h-5 text-[#00FF66]" />
              <h2 className={isDarkMode ? 'text-[#00FF66] text-xl font-bold' : 'text-emerald-700 text-xl font-bold'}>Filtros</h2>
              </div>
              <button
                type="button"
                onClick={clearAllFilters}
                className={isDarkMode
                  ? 'px-3 py-1.5 rounded-lg border border-[#00FF66]/30 text-[#9fe8b9] hover:border-[#00FF66]/55 hover:text-white text-xs'
                  : 'px-3 py-1.5 rounded-lg border border-emerald-300 text-emerald-700 hover:border-emerald-500 text-xs'
                }
              >
                Limpiar filtros
              </button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
              {renderMultiFilter({
                label: 'Mes',
                options: filtrosDisponibles.meses,
                selectedValues: selectedMeses,
                onAdd: (value) => addSelection(setSelectedMeses, value),
                onRemove: (value) => removeSelection(setSelectedMeses, value)
              })}

              {renderMultiFilter({
                label: 'Fabricante',
                options: filtrosDisponiblesFiltrados.fabricantes,
                selectedValues: selectedFabricantes,
                onAdd: (value) => addSelection(setSelectedFabricantes, value),
                onRemove: (value) => removeSelection(setSelectedFabricantes, value)
              })}

              <ClienteDropdown
                clientes={filtrosDisponiblesFiltrados.clientes}
                selectedValues={selectedClientes}
                onAdd={(value) => addSelection(setSelectedClientes, value)}
                onRemove={(value) => removeSelection(setSelectedClientes, value)}
                isDarkMode={isDarkMode}
              />

              {renderMultiFilter({
                label: 'Servicio',
                options: filtrosDisponiblesFiltrados.servicios,
                selectedValues: selectedServicios,
                onAdd: (value) => addSelection(setSelectedServicios, value),
                onRemove: (value) => removeSelection(setSelectedServicios, value)
              })}

              {renderMultiFilter({
                label: 'Moneda',
                options: filtrosDisponiblesFiltrados.monedas,
                selectedValues: selectedMonedas,
                onAdd: (value) => addSelection(setSelectedMonedas, value),
                onRemove: (value) => removeSelection(setSelectedMonedas, value)
              })}

              {renderMultiFilter({
                label: 'Proveedor',
                options: filtrosDisponiblesFiltrados.proveedores,
                selectedValues: selectedProveedores,
                onAdd: (value) => addSelection(setSelectedProveedores, value),
                onRemove: (value) => removeSelection(setSelectedProveedores, value)
              })}
            </div>

            {/* Filtro Tipo Facturación */}
            <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-[#00FF66]/10' : 'border-emerald-100'}`}>
              <div className="flex items-center gap-3 flex-wrap">
                <span className={`${textSecondary} text-xs font-semibold`}>Tipo Facturación:</span>
                {['Todos', 'Interno', 'Cliente'].map(tipo => (
                  <button
                    key={tipo}
                    type="button"
                    onClick={() => setSelectedTipoFacturacion(tipo)}
                    className={`px-3 py-1 rounded-full text-xs font-semibold border transition-all ${
                      selectedTipoFacturacion === tipo
                        ? isDarkMode
                          ? 'bg-[#00FF66]/20 text-[#00FF66] border-[#00FF66]/50'
                          : 'bg-emerald-100 text-emerald-700 border-emerald-400'
                        : isDarkMode
                          ? 'text-[#a0c8b0] border-[#00FF66]/15 hover:border-[#00FF66]/35 hover:text-[#e8fff0]'
                          : 'text-gray-600 border-gray-300 hover:border-emerald-400 hover:text-gray-900'
                    }`}
                  >
                    {tipo}
                  </button>
                ))}
              </div>
            </div>
          </div>
  
          {/* KPIs */}
          {(() => {
            const resaleCloudItem = resumenServicioData.find(s => s.servicio === 'Resale Cloud') || {};
            const cloudMgmtItem = resumenServicioData.find(s => s.servicio === 'Cloud Management') || {};

            // Clases reutilizables para la mitad inferior de cards split
            const splitDivider = isDarkMode
              ? 'border-t border-[#00FF66]/10 mt-3 pt-3'
              : 'border-t border-gray-200 mt-3 pt-3';

            return (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">

                {/* === CARD 1: INGRESO ESPERADO + COSTO REAL TOTAL === */}
                <div className={isDarkMode
                  ? 'bg-[#00261A] border border-[#00FF66]/25 border-l-4 border-l-[#00FF66] rounded-xl p-5 shadow-[0_0_10px_rgba(0,255,102,0.2)] hover:-translate-y-[3px] transition-all duration-200 relative overflow-hidden'
                  : 'bg-white border-2 border-emerald-400 border-l-4 border-l-emerald-500 rounded-xl p-5 shadow-[0_0_20px_rgba(0,200,80,0.18)] hover:shadow-[0_0_32px_rgba(0,200,80,0.28)] transition-all duration-300'
                }>
                  {isDarkMode && <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#00FF66] to-transparent" />}
                  {/* Arriba: Ingreso esperado */}
                  <div className="flex items-start justify-between">
                    <div className="flex-1 min-w-0">
                      <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest mb-1`}>Ingreso Esperado</p>
                      <p className={isDarkMode ? 'text-[#00FF66] text-lg font-bold leading-tight break-all' : 'text-emerald-600 text-lg font-bold break-all'}>
                        ${(stats.total_precio_neto || 0).toLocaleString('es-MX', {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                      </p>
                      <p className={`${textSecondary} text-xs mt-1`}>Precio neto total</p>
                    </div>
                    <div className={isDarkMode
                      ? 'w-9 h-9 rounded-xl border border-[#00FF66]/35 bg-[#00FF66]/15 flex items-center justify-center flex-shrink-0 ml-2'
                      : 'w-9 h-9 rounded-xl border border-emerald-300 bg-emerald-100 flex items-center justify-center flex-shrink-0 ml-2'
                    }>
                      <DollarSign className="w-4 h-4" style={{ color: '#00FF66' }} />
                    </div>
                  </div>
                  {/* Abajo: Costo Real */}
                  <div className={splitDivider}>
                    <div className="flex items-center justify-between">
                      <div className="flex-1 min-w-0">
                        <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest mb-1`}>Costo Real</p>
                        <p className={isDarkMode ? 'text-[#7AE8A0] text-lg font-bold break-all' : 'text-green-600 text-lg font-bold break-all'}>
                          ${(stats.total_costo_real || 0).toLocaleString('es-MX', {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                        </p>
                      </div>
                      <TrendingDown className="w-4 h-4 flex-shrink-0 ml-2 opacity-60" style={{ color: '#7AE8A0' }} />
                    </div>
                  </div>
                </div>

                {/* === CARD 2: RESALE CLOUD === */}
                <div className={cardClasses}>
                  {/* Arriba: Precio Neto Resale Cloud */}
                  <div className="flex items-start justify-between">
                    <div className="flex-1 min-w-0">
                      <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest mb-1`}>Resale Cloud</p>
                      <p className={isDarkMode ? 'text-[#00FF66] text-lg font-bold break-all' : 'text-emerald-600 text-lg font-bold break-all'}>
                        ${(resaleCloudItem.precio_neto || 0).toLocaleString('es-MX', {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                      </p>
                      <p className={`${textSecondary} text-xs mt-1`}>Precio neto</p>
                    </div>
                    <div className={isDarkMode
                      ? 'w-9 h-9 rounded-xl border border-[#00D4FF]/35 bg-[#00D4FF]/15 flex items-center justify-center flex-shrink-0 ml-2'
                      : 'w-9 h-9 rounded-xl border border-sky-300 bg-sky-100 flex items-center justify-center flex-shrink-0 ml-2'
                    }>
                      <Cloud className="w-4 h-4" style={{ color: '#00D4FF' }} />
                    </div>
                  </div>
                  {/* Abajo: Costo Real Resale Cloud */}
                  <div className={splitDivider}>
                    <div className="flex items-center justify-between">
                      <div className="flex-1 min-w-0">
                        <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest mb-1`}>Costo Real</p>
                        <p className={isDarkMode ? 'text-[#7AE8A0] text-lg font-bold break-all' : 'text-green-600 text-lg font-bold break-all'}>
                          ${(resaleCloudItem.costo_real || 0).toLocaleString('es-MX', {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                        </p>
                      </div>
                      <TrendingDown className="w-4 h-4 flex-shrink-0 ml-2 opacity-60" style={{ color: '#7AE8A0' }} />
                    </div>
                  </div>
                </div>

                {/* === CARD 3: CLOUD MANAGEMENT === */}
                <div className={cardClasses}>
                  {/* Arriba: Precio Neto Cloud Management */}
                  <div className="flex items-start justify-between">
                    <div className="flex-1 min-w-0">
                      <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest mb-1`}>Cloud Management</p>
                      <p className={isDarkMode ? 'text-[#00FF66] text-lg font-bold break-all' : 'text-emerald-600 text-lg font-bold break-all'}>
                        ${(cloudMgmtItem.precio_neto || 0).toLocaleString('es-MX', {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                      </p>
                      <p className={`${textSecondary} text-xs mt-1`}>Precio neto</p>
                    </div>
                    <div className={isDarkMode
                      ? 'w-9 h-9 rounded-xl border border-[#A56EFF]/35 bg-[#A56EFF]/15 flex items-center justify-center flex-shrink-0 ml-2'
                      : 'w-9 h-9 rounded-xl border border-violet-300 bg-violet-100 flex items-center justify-center flex-shrink-0 ml-2'
                    }>
                      <Server className="w-4 h-4" style={{ color: '#A56EFF' }} />
                    </div>
                  </div>
                  {/* Abajo: Costo Real Cloud Management */}
                  <div className={splitDivider}>
                    <div className="flex items-center justify-between">
                      <div className="flex-1 min-w-0">
                        <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest mb-1`}>Costo Real</p>
                        <p className={isDarkMode ? 'text-[#7AE8A0] text-lg font-bold break-all' : 'text-green-600 text-lg font-bold break-all'}>
                          ${(cloudMgmtItem.costo_real || 0).toLocaleString('es-MX', {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                        </p>
                      </div>
                      <TrendingDown className="w-4 h-4 flex-shrink-0 ml-2 opacity-60" style={{ color: '#7AE8A0' }} />
                    </div>
                  </div>
                </div>

                {/* === CARD 4: DESCUENTO APLICADO === */}
                <div className={cardClasses}>
                  <div className="flex items-start justify-between">
                    <div className="flex-1 min-w-0">
                      <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest mb-1`}>Descuento Aplicado</p>
                      <p className={isDarkMode ? 'text-[#FFD700] text-lg font-bold break-all' : 'text-amber-600 text-lg font-bold break-all'}>
                        ${(stats.total_descuento_aplicado || 0).toLocaleString('es-MX', {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                      </p>
                      <p className={`${textSecondary} text-xs mt-1`}>
                        {stats.total_precio_neto > 0
                          ? `${((stats.total_descuento_aplicado / stats.total_precio_neto) * 100).toFixed(1)}% del ingreso`
                          : 'Sin datos'}
                      </p>
                    </div>
                    <div className={isDarkMode
                      ? 'w-9 h-9 rounded-xl border border-[#FFD700]/35 bg-[#FFD700]/15 flex items-center justify-center flex-shrink-0 ml-2'
                      : 'w-9 h-9 rounded-xl border border-amber-300 bg-amber-100 flex items-center justify-center flex-shrink-0 ml-2'
                    }>
                      <Tag className="w-4 h-4" style={{ color: '#FFD700' }} />
                    </div>
                  </div>
                </div>

                {/* === CARD 5: UTILIDAD + MARGEN PROMEDIO === */}
                <div className={cardClasses}>
                  {/* Arriba: Utilidad */}
                  <div className="flex items-start justify-between">
                    <div className="flex-1 min-w-0">
                      <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest mb-1`}>Utilidad</p>
                      <p className={isDarkMode ? 'text-[#00ffb3] text-lg font-bold break-all' : 'text-teal-700 text-lg font-bold break-all'}>
                        ${(stats.total_utilidad || 0).toLocaleString('es-MX', {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                      </p>
                    </div>
                    <div className={isDarkMode
                      ? 'w-9 h-9 rounded-xl border border-[#00D4AA]/35 bg-[#00D4AA]/15 flex items-center justify-center flex-shrink-0 ml-2'
                      : 'w-9 h-9 rounded-xl border border-teal-300 bg-teal-100 flex items-center justify-center flex-shrink-0 ml-2'
                    }>
                      <TrendingUp className="w-4 h-4" style={{ color: '#00D4AA' }} />
                    </div>
                  </div>
                  {/* Abajo: Margen Promedio */}
                  <div className={splitDivider}>
                    <div className="flex items-center justify-between">
                      <div className="flex-1 min-w-0">
                        <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest mb-1`}>Margen Promedio</p>
                        <p className={isDarkMode ? 'text-[#00ffb3] text-lg font-bold' : 'text-teal-700 text-lg font-bold'}>
                          {(stats.margen_promedio || 0).toLocaleString('es-MX', {maximumFractionDigits: 1, minimumFractionDigits: 1})}%
                        </p>
                      </div>
                      <Briefcase className="w-4 h-4 flex-shrink-0 ml-2 opacity-60" style={{ color: '#00D4AA' }} />
                    </div>
                  </div>
                </div>

              </div>
            );
          })()}
  
          {/* Tablas Compactas */}
          <TablasCompactas
            precioXClienteData={precioXClienteData}
            precioXFabricanteData={precioXFabricanteData}
            precioXProveedorData={precioXProveedorData}
            resumenServicioData={resumenServicioData}
            isDarkMode={isDarkMode}
            onClienteClick={handleClienteClick}
            onFabricanteClick={handleFabricanteClick}
            onServicioClick={handleServicioClick}
            onProveedorClick={(value) => handleFabricanteClick(value, 'proveedor')}
            selectedClientes={selectedClientes}
            selectedFabricantes={selectedFabricantes}
            selectedServicios={selectedServicios}
            selectedProveedores={selectedProveedores}
          />

          {/* Graficas pie */}
          <GraficasPieBilling
            precioXFabricanteData={precioXFabricanteData}
            evolucionData={evolucionData}
            isDarkMode={isDarkMode}
            onFabricanteClick={handleFabricanteClick}
            selectedFabricantes={selectedFabricantes}
          />
  
          {/* Análisis de Presupuesto */}
          <div className={cardClasses}>
            <div className="flex items-center gap-3 mb-4">
              <div className={isDarkMode ? 'w-1 h-6 rounded-full bg-[#00FF66]' : 'w-1 h-6 rounded-full bg-emerald-500'} />
              <h3 className={isDarkMode ? 'text-[#00FF66] text-xl font-bold' : 'text-emerald-700 text-xl font-bold'}>
                Información Adicional
              </h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className={`p-4 rounded-lg border ${
                isDarkMode ? 'bg-[#00FF66]/5 border-[#00FF66]/15' : 'bg-emerald-50 border-emerald-200'
              }`}>
                <p className={textSecondary}>Registros detallados</p>
                <p className={isDarkMode ? 'text-[#00FF66] text-2xl font-bold mt-1' : 'text-emerald-700 text-2xl font-bold mt-1'}>{detalleData.length}</p>
              </div>
              <div className={`p-4 rounded-lg border ${
                isDarkMode ? 'bg-[#00FF66]/5 border-[#00FF66]/15' : 'bg-emerald-50 border-emerald-200'
              }`}>
                <p className={textSecondary}>Fabricantes</p>
                <p className={isDarkMode ? 'text-[#00FF66] text-2xl font-bold mt-1' : 'text-emerald-700 text-2xl font-bold mt-1'}>{precioXFabricanteData.length}</p>
              </div>
              <div className={`p-4 rounded-lg border ${
                isDarkMode ? 'bg-[#00FF66]/5 border-[#00FF66]/15' : 'bg-emerald-50 border-emerald-200'
              }`}>
                <p className={textSecondary}>Servicios</p>
                <p className={isDarkMode ? 'text-[#00FF66] text-2xl font-bold mt-1' : 'text-emerald-700 text-2xl font-bold mt-1'}>{resumenServicioData.length}</p>
              </div>
            </div>
          </div>

          <HorasXStatus
            isDarkMode={isDarkMode}
            selectedClientes={selectedClientes}
            selectedMeses={selectedMeses}
            selectedFabricantes={selectedFabricantes}
            selectedServicios={selectedServicios}
            selectedMonedas={selectedMonedas}
            selectedProveedores={selectedProveedores}
            filtrosDisponibles={filtrosDisponibles}
          />

          {/* Detalle de facturación */}
          <DetalleFacturacionTable
            records={detalleData}
            isDarkMode={isDarkMode}
            tiposCambio={tiposCambio}
            monedaVisualizacion={monedaVisualizacion}
          />
        </div>
      </div>
    );
  }
